/**
 * Permissions constants - Single source of truth for module definitions,
 * categories, and permission helpers.
 */

// Module key -> display config
// orgRestriction: null = available in both orgs, 'EPL' = EPL only, 'BARE' = BARE only
export const MODULE_DEFINITIONS = {
  dashboard:          { label: 'Dashboard',          category: 'CORE',             orgRestriction: null },
  order_processing:   { label: 'Order Processing',   category: 'ORDER MANAGEMENT', orgRestriction: null },
  transfer_orders:    { label: 'Transfer Orders',    category: 'ORDER MANAGEMENT', orgRestriction: 'EPL' },
  raw_materials:      { label: 'Raw Materials',      category: 'INVENTORY',        orgRestriction: null },
  donor_management:   { label: 'Donor Management',   category: 'INVENTORY',        orgRestriction: 'EPL' },
  receive_inventory:  { label: 'Receive Inventory',  category: 'INVENTORY',        orgRestriction: null },
  epl_calendar:       { label: 'EPL Calendar',       category: 'OPERATIONS',       orgRestriction: 'EPL' },
  promo_codes:        { label: 'Promo Codes',        category: 'OPERATIONS',       orgRestriction: null },
  client_management:  { label: 'Client Management',  category: 'CLIENTS & REPS',   orgRestriction: null },
  rep_management:     { label: 'Rep Management',     category: 'CLIENTS & REPS',   orgRestriction: null },
  accounting:         { label: 'Accounting',          category: 'ADMIN',            orgRestriction: 'EPL' },
  client_analytics:   { label: 'Client Analytics',   category: 'ANALYTICS',        orgRestriction: null },
  resources:          { label: 'Resources',           category: 'ADMIN',            orgRestriction: null },
  purchase_orders:    { label: 'Purchase Orders',     category: 'ADMIN',            orgRestriction: null },
  system_settings:    { label: 'System Settings',     category: 'ADMIN',            orgRestriction: null },
};

// Category display order
export const PERMISSION_CATEGORIES = [
  'CORE',
  'ORDER MANAGEMENT',
  'INVENTORY',
  'OPERATIONS',
  'CLIENTS & REPS',
  'ANALYTICS',
  'ADMIN',
];

// Access levels
export const ACCESS_LEVELS = {
  NONE: 'none',
  VIEW: 'view',
  EDIT: 'edit',
};

// Maps sidebar menu text -> module key (used by InternalNavigation)
export const MENU_TEXT_TO_MODULE_KEY = {
  'Dashboard': 'dashboard',
  'Order Processing': 'order_processing',
  'Transfer Orders': 'transfer_orders',
  'Raw Materials': 'raw_materials',
  'Donor Management': 'donor_management',
  'Receive Inventory': 'receive_inventory',
  'EPL Calendar': 'epl_calendar',
  'Promo Codes': 'promo_codes',
  'Client Management': 'client_management',
  'Rep Management': 'rep_management',
  'Accounting': 'accounting',
  'Client Analytics': 'client_analytics',
  'Resources': 'resources',
  'Purchase Orders': 'purchase_orders',
  'System Settings': 'system_settings',
};

// Maps URL path segments (after /internal/{org}/) to module keys
// Used by InternalNavigation for route-level permission blocking
export const PATH_TO_MODULE_KEY = {
  'order-processing':         'order_processing',
  'transfer-orders':          'transfer_orders',
  'raw-materials':            'raw_materials',
  'donor-management':         'donor_management',
  'receive-inventory':        'receive_inventory',
  'purchase-orders':          'purchase_orders',
  'client-management':        'client_management',
  'client-analytics':         'client_analytics',
  'settings':                 'system_settings',
  'admin/promo-codes':        'promo_codes',
  'admin/rep-management':     'rep_management',
  'admin/accounting':         'accounting',
  'admin/invoice-management': 'accounting',
  'admin/resources':          'resources',
  'admin/calendar':           'epl_calendar',
};

// Build default permissions (everything visible with edit access)
export const getDefaultPermissions = (organization = 'BARE') => {
  const modules = {};
  Object.keys(MODULE_DEFINITIONS).forEach(key => {
    modules[key] = { visible: true, access: 'edit' };
  });
  return { modules };
};

// Get modules grouped by category (for UI rendering)
export const getModulesByCategory = () => {
  const grouped = {};
  PERMISSION_CATEGORIES.forEach(cat => {
    grouped[cat] = [];
  });
  Object.entries(MODULE_DEFINITIONS).forEach(([key, def]) => {
    if (grouped[def.category]) {
      grouped[def.category].push({ key, ...def });
    }
  });
  return grouped;
};
